export default {"src":"/_next/static/media/pinterest.8b6a4d18.svg","height":25,"width":20,"blurWidth":0,"blurHeight":0};